import { gql, useSubscription } from '@apollo/client';
import { useEffect, useState } from 'react';

const RECEIVE_PASTE_SUBSCRIPTION = gql`
    subscription ReceivePaste($receiver: String!) {
  receivePaste(receiver: $receiver) {
    id
    content
    sender
    receiver
    timestamp
  }
}
`;

interface Paste {
  content: string;
  receiver: string;
  sender: string;
  timestamp: string;
}

export default function useReceivePaste(receiver: string) {
    const [paste, setPaste] = useState<Paste | null>(null);
    const { loading, error } = useSubscription(RECEIVE_PASTE_SUBSCRIPTION, { variables: { receiver }, onSubscriptionData: ({subscriptionData}) => setPaste(subscriptionData?.data?.receivePaste) });
    // useEffect(() => { setPaste(data?.receivePaste) }, [data])

    // console.log(data)

    return {paste, loading, error}
}